import {OpenAI} from 'openai'
import {openIAKey} from './constKeys'

const configuration = {
  apiKey: openIAKey,
  dangerouslyAllowBrowser: true
}
export const openai = new OpenAI(configuration)

